import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=bb12b520&scoped=true"
import script from "./SlotMachine.vue?vue&type=script&lang=js"
export * from "./SlotMachine.vue?vue&type=script&lang=js"
import style0 from "./SlotMachine.vue?vue&type=style&index=0&id=bb12b520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb12b520",
  null
  
)

export default component.exports